<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container d-flex flex-column bg-gray">
        <header class="mdc-top-app-bar position-static">
          <div class="mdc-top-app-bar__row">
            <section
              class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start"
            >
              <!-- <a class="material-icons mdc-top-app-bar__navigation-icon" @click="routerGoPrev()">close</a> -->
              <a
                class="material-icons mdc-top-app-bar__navigation-icon"
                @click="goBackToSurvey"
                >close</a
              >
            </section>

            <section class="mdc-top-app-bar__section title">
              <div class="mdc-top-app-bar__title">
                {{ $t("704") }}
                <!-- {{setTitle}} -->
                <!-- 설문 조사 -->
              </div>
            </section>

            <section
              class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end"
            >
              <a
                class="material-icons mdc-top-app-bar__action-item"
                aria-label="search"
                alt="search"
              ></a>
            </section>
          </div>
        </header>

        <section class="flex-grow-1 scroll-y" v-if="surveyData">
          <div class="pdt-16 pdr-16 pdb-16 pdl-16">
            <!-- 제목 영역 -->
            <div class="t-headline10 t-line-h-30">
              {{ surveyData.name }}
              <!-- 비즈니스 전문가 과정 설문 조사: 예측 가능한 분석 -->
            </div>

            <div class="t-bpdy3 t-color-content1 mgt-8">
              {{ surveyData.summary }}
              <!-- 이 설문은 비즈니스 전문가 과정을 개설을 위해 실시하는 설문 조사입니다. -->
            </div>

            <div class="d-grid mgt-16">
              <div class="mdc-card mdc-elevation--z3 grid-row-1">
                <div class="pda-default text-center">
                  <div class="t-headline9">
                    {{ surveyData.questionCount }}
                  </div>
                  <div class="t-body3 t-color-content1 mgt-21">
                    {{ $t("705") }}
                    <!-- 문항 개수 -->
                  </div>
                </div>
              </div>

              <div class="mdc-card mdc-elevation--z3 grid-row-1">
                <div class="pda-default text-center pdt-18 pdb-18">
                  <div class="t-headline9">
                    {{ finalTime }}
                  </div>
                  <div class="t-body3 t-color-content1 mgt-21">
                    {{ $t("706") }}
                    <!-- 설문 제한 시간 -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section v-if="surveyData">
          <div class="pda-default">
            <button
              class="mdc-button mdc-button--raised btn-red w-full btn-big"
              @click="moveSurveyTakeWithLearnId()"
              v-if="
                surveyData.progression.value === 'RESPONDENT' ||
                surveyData.progression.value === 'RESPONDING'
              "
            >
              {{ $t("707") }}
              <!-- 시작하기 -->
            </button>

            <button
              class="mdc-button mdc-button--raised btn-white w-full btn-big"
              @click="moveSurveyResult()"
              v-if="surveyData.progression.value === 'SUBMITTED'"
            >
              {{ $t("708") }}
              <!-- 지난 결과 확인 -->
            </button>

            <button
              class="mdc-button mdc-button--raised btn-red w-full btn-big"
              v-if="surveyData.progression.value === 'WAITING'"
              disabled
            >
              {{ $t("709") }}
              <!-- 2019.12.31부터 응답 가능 -->
            </button>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 설문 인트로 컴포넌트(survey intro main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import surveyApi from "@/api/surveyApi.js";
import { surveyMixin } from "@/mixins/survey.js";

export default {
  name: "surveyIntro",

  mixins: [surveyMixin],

  data() {
    return {
      surveyData: null,
      surveyMinit: 0,
      surveySec: 0,
      finalTime: 0,
    };
  },

  created() {
    this.fatchData();
  },

  methods: {
    // get survey respondent intro data
    fatchData() {
      let params = {
        respondentId: this.$route.params.respondentId,
      };
      surveyApi.surveyRespondentIntro(params).then((response) => {
        this.surveyData = response.data.data;
        if (this.surveyData.useTimeout) {
          this.surveyMinit = Math.floor(parseInt(this.surveyData.timeout) / 60);
          //   this.surveySec = Math.floor(
          //     this.surveyData.timeout - this.surveyMinit * 60
          //   );
          this.finalTime =
            this.surveyData.timeout.toFixed() +
            "m" +
            " " +
            this.surveySec.toFixed() +
            "sec";
        } else {
          this.finalTime = this.$t('3328')
        }

        surveyData.useTimeout;
      });
    },

    moveSurveyResult() {
      console.log("moveSurveyResult");
      let params = {
        respondentId: this.$route.params.respondentId,
      };

      this.$router.push({
        name: "IndependentSurveyResult",
        params: params,
      });
    },
    moveSurveyTakeWithLearnId() {
      this.$router.push({
        name: "IndependentSurveyTake",
        query: {
          status: this.$route.query.status,
          learnId: this.$route.query.learnId,
          distributionType: this.$route.query.distributionType,
        },
      });
    },
    goBackToSurvey() {
      if (this.$route.query.distributionType == "SATISFACTION") {
        this.$router.push(
          "/learn/" +
            this.$route.query.learnId +
            "?status=" +
            this.$route.query.status +
            "&tab=viewSurvey"
        );
      } else {
        this.$router.push({
          name: "IndependentSurveyTotalView",
          params: { distId: this.$route.params.distId },
          query: this.$route.query,
        });
      }
    },
  },
};
</script>
